import React from "react";
import { Outlet } from "react-router-dom";

const AdminAuthContainer = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-4 relative">
      <Outlet />
    </div>
  );
};

export default AdminAuthContainer;
